import { Injectable } from '@angular/core';
import io from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private socket;
  chatBotUrl = environment.ChatBotNew;
  constructor(private readonly http: HttpClient) {}

  public connect(url: string, path: string) {
    console.log(`chatbot url: ${url}, ${path}`)
    const tokenvalues = sessionStorage.getItem('fbToken') ? sessionStorage.getItem('fbToken') : '';
    const username = sessionStorage.getItem('username') ? sessionStorage.getItem('username') : '';
    const email = sessionStorage.getItem('email') ? sessionStorage.getItem('email') : '';
    const id = sessionStorage.getItem('id') ? sessionStorage.getItem('id') : '';
    this.socket = io(url, {
      path: `${path}socket.io`,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: Infinity,
      forceNew: true,
      secure: true,
      query: {
        token: tokenvalues ? tokenvalues : '',
        username: username ? username : 'Tulasireddy',
        email: email ? email : 'tulasi@cardinality.ai',
        id: id ? id : '1234'
      }
    });
    this.socket.on('connect', () => {
      this.socket.emit('session_request', { session_id: this.socket.id });
    });
    this.socket.on('session_confirm', _remote_id => {
      //not to be empty
    });
    this.socket.on('connect_error', error => {
      console.log(error);
    });

    this.socket.on('error', error => {
      console.log(error);
    });

    this.socket.on('disconnect', reason => {
      console.log(reason);
    });
  }

  public sendMessage(message) {
    const tokenvalues = sessionStorage.getItem('fbToken') ? sessionStorage.getItem('fbToken') : '';
    const username = sessionStorage.getItem('username') ? sessionStorage.getItem('username') : '';
    const email = sessionStorage.getItem('email') ? sessionStorage.getItem('email') : '';
    const id = sessionStorage.getItem('id') ? sessionStorage.getItem('id') : '';
    this.socket.emit('user_uttered', {
      message: message,
      customData: {
        token: tokenvalues ? tokenvalues : '',
        username: username ? username : '',
        email: email ? email : '',
        id: id ? id : ''
      }
    });
  }

  public getMessages = () => {
    return new Observable(observer => {
      this.socket.on('bot_uttered', message => {
        observer.next(message);
      });
    });
  };
  public disconnect() {
    this.socket.on('disconnect', reason => {
      console.log(reason);
    });
  }
  public searchMenus(modal) {
    const inputRequest = {
      query: modal
    };
    return this.http.post(this.chatBotUrl + 'search', inputRequest);
  }
  public sendFeedback(modal) {
    const inputRequest = {
      user: sessionStorage.getItem('username') ? sessionStorage.getItem('username') : '',
      question: modal.question,
      isLiked: modal.islike ? true : false
    };
    return this.http.post(this.chatBotUrl + 'feedback', inputRequest);
  }
}
